import { APIConfigSet } from '../../dao-generator';

const journalOperateModule: APIConfigSet = {
  // 拉取 journal 日志
  getJournal: {
    method: 'get',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{dirNode}',
    queryKeys: {
      required: ['access_token', 'syncId'],
      noRequired: ['ssn_marker', 'journal_marker', 'journal_limit'],
    },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { journal_limit: 1000 },
  },
};

const fileOperateModule: APIConfigSet = {
  // 查询文件/子目录是否存在
  checkPathAvailabel: {
    method: 'head',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{dirNode}/fs/{relativePath}',
    queryKeys: { required: ['access_token', 'ssn', 'syncId'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
  // 获取文件/子目录信息和文件下载地址
  getPathInfo: {
    method: 'get',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{dirNode}/fs/{relativePath}',
    actionKey: 'info',
    queryKeys: { required: ['access_token', 'syncId'], noRequired: ['ssn', 'pre_check'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { pre_check: true },
  },
  // 获取文件下载的cosUrl
  getPathCosUrl: {
    method: 'get',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{dirNode}/fs/{relativePath}',
    actionKey: 'info',
    queryKeys: { required: ['access_token', 'syncId'], noRequired: ['ssn', 'domainTag'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
  // 列出子目录
  listPath: {
    method: 'get',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{dirNode}/fs/{relativePath}',
    queryKeys: {
      required: ['access_token', 'ssn_deletion', 'syncId'],
      noRequired: ['marker', 'limit'],
    },
    autoParams: { libraryId: '', spaceId: '', access_token: '', limit: 1000 },
  },
  // 开始简单上传文件
  uploadFile: {
    method: 'put',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{dirNode}/fs/{relativePath}',
    queryKeys: {
      required: ['access_token', 'syncId'],
      noRequired: ['conflict_resolution_strategy', 'fileSize', 'ssn'],
    },
    bodyKeys: { noRequired: ['fullHash', 'beginningHash', 'size', 'modificationTime'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { relativePath: '', conflict_resolution_strategy: 'rename' },
  },
  // 开始分块上传文件
  uploadMultiPartFile: {
    method: 'post',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{dirNode}/fs/{relativePath}',
    actionKey: 'multipart',
    queryKeys: {
      required: ['access_token', 'syncId'],
      noRequired: ['conflict_resolution_strategy', 'fileSize', 'ssn'],
    },
    bodyKeys: { noRequired: ['partNumberRange', 'modificationTime'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { relativePath: '', conflict_resolution_strategy: 'rename' },
  },
  // 分块上传任务续期
  updateMultiPartFileInfo: {
    method: 'post',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{confirmKey}',
    actionKey: 'renew',
    queryKeys: { required: ['access_token', 'syncId'] },
    bodyKeys: { noRequired: ['partNumberRange'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { confirmKey: '' },
  },
  // 完成上传文件
  confirmUploadFile: {
    method: 'post',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{confirmKey}',
    actionKey: 'confirm',
    queryKeys: {
      required: ['access_token', 'syncId'],
      noRequired: ['conflict_resolution_strategy'],
    },
    bodyKeys: { noRequired: ['crc64'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { confirmKey: '' },
  },
  // 获取文件上传任务状态
  getFileUploadStatus: {
    method: 'get',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{confirmKey}',
    actionKey: 'upload',
    queryKeys: { required: ['access_token', 'syncId'], noRequired: ['no_upload_part_info'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { confirmKey: '' },
  },
  // 取消上传任务
  cancelFileUpload: {
    method: 'delete',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{confirmKey}',
    actionKey: 'upload',
    queryKeys: { required: ['access_token', 'syncId'] },
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
    defaultParams: { confirmKey: '' },
  },
  // 同步批量操作
  batchOperate: {
    method: 'post',
    path: '/api/v1/fs-journal/{libraryId}/{spaceId}/{dirNode}/fs',
    queryKeys: { required: ['access_token', 'syncId'] },
    bodyKeys: 'custom',
    autoParams: { libraryId: '', spaceId: '', access_token: '' },
  },
};

const syncRequestItemSet: APIConfigSet = {
  ...journalOperateModule,
  ...fileOperateModule,
};

export default syncRequestItemSet;
